module.exports = __webpack_public_path__ + "static/profile-page-fn-5460bcad04166df17c141b9ab43a2adf.png";